<template>
    <div>
        <div class="categoryComp" id="courseCategoryArea">

            <ul ref="courseLeft" class="categoryTree noMargin noPadding alignCenter hiddenScrollbar">
                <li v-on:click="changeTag(null)" data-id=""  class="firstLevelCategory" :class="{active: !selectedId }">
                    <span class="block color333 hand" >
                        全部文库
                    </span>
                </li>
                <li class="firstLevelCategory" v-for="(item,index) in tagList" :key="index"
                    :class="{active: item.id == selectedId}">
                        <span class="block color333 hand" :data-id="item.id"
                              v-on:click="changeTag(item)">{{item.title}}</span>

<!--                    <ul class="noPadding" style="font-size: 80%">-->
<!--                        <li class="subItem" :class="{active: subItem.id == selectedSecondId}" v-for="(subItem,index) in (item.subList ? item.subList : [])" :key="index">-->
<!--                            <span class="block" :data-id="item.id" :data-secondcategoryid="subItem.id"-->
<!--                                v-on:click="onChange">{{subItem.title}}</span>-->
<!--                        </li>-->
<!--                    </ul>-->

                </li>

            </ul>
        </div>
    </div>
</template>
<script>
// part
import shixunPagePart from '../shixunApp/shixunPagePart';

// data and api
import categoryApi from '@/api/category';

// style
import './category.scss'
import datumApi from "@api/datum";
import appHelper from "@util/appHelper";

const config = {
    apiConfig : {
    }
};

export default {
    name: "courseListLeft",
    extends : shixunPagePart,
    props : {
        activeId : String
    },
    data(){
        return{

            // enableDataList : true,
            // autoLoadDataList : true,

            scrollToLoadNextPage:false,
            apiConfig : config.apiConfig,
            scrollControl:{
                viewContainer:window,
                scrollContainer : ".hiddenScrollbar"
            },

            selectedId: '',
            selectedFirstId : '',
            selectedSecondId : '',

            outputMap : {},
            layoutAdjustTimer : null,

            categoryList : [],
            tagList : []
        }
    },
    methods: {
        loadCategoryList() {
            categoryApi.loadList('DATUM', (list) => {
                this.categoryList = list;
            });
        },
        onChangeCategory: function (event) {
            let target = event.currentTarget;
            const id = target.dataset.id || '';
            // let secondcategoryid = target.dataset.secondcategoryid || '';
            // let params = {}
            // params.secondCategory = secondcategoryid
            // params.firstCategory = id

            // this.$emit('changeCategory',params);
            this.$emit('changeCategory', {
                id : id
            });
            // set selected id
            // this.selectedId = this.selectedFirstId = id;
            // this.selectedSecondId = secondcategoryid;
        },
        changeTag: function (item) {

            // if (!item)
            // {
            //     appHelper.goToPage('datumIndex');
            //     return;
            // }

            this.$emit('changeTag', {
                id : item ? item.id : null,
                data : item
            });
            this.selectedId = this.selectedFirstId = item ? item.id : '';
        },
        setTagId(tagId) {
            this.selectedId = tagId;
        },

        loadTagList() {
            datumApi.getTagList((result) => {
                this.tagList = result.data.lengthwaysTagList;
                this.typeFilterList = result.data.transverseTagList;
            });
        },

        setSelectedId(id) {
            this.selectedId = id;
        }

    },
    mounted(){
        this.loadTagList();
        // this.loadCategoryList();
    }

}
</script>
<style lang="scss" scoped>

</style>
